import React from 'react'
import { BlockContainerProps } from './types'
import { TitleSection } from '../TitleSection'
import styles from './BlockContainer.module.scss'

export const StyledBlockContainer: React.FC<BlockContainerProps> = (props: BlockContainerProps) => {
  return (
    <div className={`${props.className || ''}`}>
      <div className={`flex flex-col w-full items-center text-member-gray-100 rounded-L ${styles.container} mx-auto`}>
        <TitleSection title={props.title} text={props.text} />
        {props.children}
      </div>
    </div>
  )
}
